import { useEffect } from 'react'
import { Toaster, type ExternalToast } from 'sonner'
import { Store, useStore } from '../lib/emitter'

/** Distance from the bottom edge; pages with a bottom bar (the studio) lift the toasts above it. */
const bottomInset = new Store<number | null>(null)

export function useToastsAbove(px: number) {
  useEffect(() => {
    bottomInset.set(px)
    return () => bottomInset.set(null)
  }, [px])
}

/**
 * Options for a toast that takes over the slot `id`. Sonner merges an update into the toast it
 * replaces, so "is back" would keep the description and duration of "dropped out" otherwise.
 */
export const slot = (id: string, opts: Omit<ExternalToast, 'id'> = {}): ExternalToast => ({
  description: undefined,
  duration: undefined,
  action: undefined,
  ...opts,
  id,
})

export function AppToaster() {
  const bottom = useStore(bottomInset)
  const offset = bottom === null ? undefined : { bottom }
  return (
    <Toaster
      theme="dark"
      position="bottom-right"
      closeButton
      offset={offset}
      mobileOffset={offset}
      toastOptions={{
        unstyled: true,
        classNames: {
          toast: 'toast',
          title: 'toast-title',
          description: 'toast-description',
          icon: 'toast-icon',
          closeButton: 'toast-close',
          actionButton: 'toast-action',
          cancelButton: 'toast-cancel',
          success: 'toast-success',
          error: 'toast-error',
          warning: 'toast-warning',
          info: 'toast-info',
        },
      }}
    />
  )
}
